var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconLigthBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 13641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 6.5H5.09074",
    stroke: "#009DAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.09074 6.50004H1L3.53484 1H12.1467L14.6862 6.50004H10.5908",
    stroke: "#009DAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5962 6.5C10.5668 7.20962 10.2642 7.88038 9.75168 8.37207C9.23918 8.86376 8.55644 9.13831 7.84621 9.13831C7.13598 9.13831 6.45324 8.86376 5.94073 8.37207C5.42823 7.88038 5.12562 7.20962 5.09619 6.5",
    stroke: "#009DAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6862 6.5V10.5293C14.6862 10.9193 14.5313 11.2934 14.2555 11.5692C13.9796 11.8451 13.6055 12 13.2155 12H2.47551C2.085 12 1.71041 11.8452 1.43384 11.5695C1.15726 11.2938 1.00125 10.9198 1 10.5293V6.5",
    stroke: "#009DAC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconLigthBlue);
export default __webpack_public_path__ + "static/media/downloadIcon_ligthBlue.d746ae32d80caee590acf4081c0494a2.svg";
export { ForwardRef as ReactComponent };